/* ZR · GIOSTRA (Mirco 27.10, seconda versione: "preferisco che si muove e va al centro una, si muove e va al centro una").
   Una fila con [data-giostra="secondi fra uno scatto e l'altro"] avanza di UNA card alla volta e la ferma al CENTRO;
   la card al centro è piena, le altre un po' più piccole e spente. È senza fine: le card sono copiate prima e dopo, e
   quando si arriva alle copie si torna sull'originale uguale senza che si veda.
   Si ferma col mouse sopra o toccandola; col dito si scorre e si aggancia da sola alla card più vicina; le frecce
   [data-giostra-dir="1|-1"] stanno dentro lo stesso [data-giostra-box]. Niente movimento continuo: costa poco al telefono. */
(function () {
  if (window.zrGiostra) { window.zrGiostra(); return; }
  var ridotto = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var st = document.createElement('style');
  st.textContent = '[data-giostra]{scroll-snap-type:x mandatory;scroll-behavior:auto}'
    + '[data-giostra]>*{scroll-snap-align:center;transition:transform .55s cubic-bezier(.2,.8,.2,1),opacity .55s}'
    + '[data-giostra]>*:not(.giostra-centro){transform:scale(.93);opacity:.6}';
  document.head.appendChild(st);
  function avvia(p) {
    if (p.__giostra) return; p.__giostra = 1;
    var orig = Array.prototype.slice.call(p.children), n = orig.length;
    if (n < 3) return;
    if (getComputedStyle(p).position === 'static') p.style.position = 'relative'; // cosi offsetLeft delle card e misurato dalla fila
    function copia(c) {
      var k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); k.setAttribute('tabindex', '-1');
      k.querySelectorAll('a,button').forEach(function (x) { x.setAttribute('tabindex', '-1'); }); return k;
    }
    var prima = document.createDocumentFragment(); orig.forEach(function (c) { prima.appendChild(copia(c)); });
    p.insertBefore(prima, p.firstChild);
    orig.forEach(function (c) { p.appendChild(copia(c)); });
    var ogni = (Number(p.getAttribute('data-giostra')) || 3.2) * 1000;
    var i = n, mio = false, fermoFino = 0, sopra = false, vis = true, tFine = null;
    function sinistra(k) { var c = p.children[k]; return c.offsetLeft + c.offsetWidth / 2 - p.clientWidth / 2; }
    function segna() { for (var k = 0; k < p.children.length; k++) p.children[k].classList.toggle('giostra-centro', k === i); }
    function salta(k) { i = k; mio = true; p.scrollTo({left: sinistra(i), behavior: 'instant'}); segna(); setTimeout(function () { mio = false; }, 60); }
    // dopo uno scatto, se siamo sulle copie si torna sull'originale uguale (stessa immagine, nessun salto visibile)
    function normalizza() { if (i >= 2 * n) salta(i - n); else if (i < n) salta(i + n); }
    function vai(d) {
      i += d; segna(); mio = true;
      p.scrollTo({left: sinistra(i), behavior: ridotto ? 'instant' : 'smooth'});
      clearTimeout(tFine); tFine = setTimeout(function () { mio = false; normalizza(); }, 650);
    }
    // il dito o la rotellina: quando si ferma, la card più vicina al centro diventa quella "giusta"
    var tDito = null;
    p.addEventListener('scroll', function () {
      if (mio) return;
      clearTimeout(tDito);
      tDito = setTimeout(function () {
        var centro = p.scrollLeft + p.clientWidth / 2, best = i, dist = 1e9;
        for (var k = 0; k < p.children.length; k++) { var c = p.children[k], m = c.offsetLeft + c.offsetWidth / 2, dd = Math.abs(m - centro); if (dd < dist) { dist = dd; best = k; } }
        i = best; segna(); normalizza(); fermoFino = Date.now() + 4000;
      }, 160);
    }, {passive: true});
    p.addEventListener('mouseenter', function () { sopra = true; });
    p.addEventListener('mouseleave', function () { sopra = false; });
    p.addEventListener('touchstart', function () { fermoFino = Date.now() + 60000; }, {passive: true});
    p.addEventListener('touchend', function () { fermoFino = Date.now() + 4000; }, {passive: true});
    var box = p.closest('[data-giostra-box]') || p.parentNode;
    box.querySelectorAll('[data-giostra-dir]').forEach(function (b) {
      b.addEventListener('click', function () { fermoFino = Date.now() + 5000; vai(Number(b.getAttribute('data-giostra-dir'))); });
    });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { vis = e[0].isIntersecting; }).observe(p);
    // al primo giro la fila parte già con la prima card al centro
    salta(n);
    window.addEventListener('resize', function () { salta(i); });
    if (!ridotto) setInterval(function () { if (vis && !sopra && !document.hidden && Date.now() > fermoFino) vai(1); }, ogni);
  }
  window.zrGiostra = function () { document.querySelectorAll('[data-giostra]').forEach(avvia); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.zrGiostra); else window.zrGiostra();
})();
